import { useSelector } from "react-redux";

import OrganizationFeature from "@mapmycustomers/shared/enum/OrganizationFeature";
import { OrganizationMetaData } from "@mapmycustomers/shared/types/Organization";

import { getFeatures } from "@app/store/iam";

const useFeatures = () => {
  const features: OrganizationMetaData["features"] = useSelector(getFeatures);
  return {
    features,
    hasAllFeatures: (...query: OrganizationFeature[]) =>
      query.every((feature) => features?.[feature]?.enabled),
    hasFeature: (feature: OrganizationFeature) => !!features?.[feature]?.enabled,
  };
};

export default useFeatures;
